import React from "react";
import { useTranslation } from "react-i18next";

//UI Icons
import AssignmentIndOutlinedIcon from '@mui/icons-material/AssignmentIndOutlined';

//Custom Components
import TableHeaderButton from "./TableHeaderButton";
import { ITableHeaderButtonRefreshProps } from "@/@types/ui/Table";

function TableButtonRefresh(props: ITableHeaderButtonRefreshProps) {
  const { t } = useTranslation();
  const { label } = props;

  return (
    <TableHeaderButton variant="contained" startIcon={<AssignmentIndOutlinedIcon />} {...props}>
      {label ? label : t("common.status")}
    </TableHeaderButton>
  );
}

export default TableButtonRefresh;
